module.exports = __webpack_public_path__ + "img/top4.301fe81a.png";